var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:`${_vm.blockClass}user-link`,attrs:{"href":_vm.user.url}},[_c('span',{class:["a-user-role", _vm.roleClass]},[_c('img',{class:[`${_vm.blockClass}user-icon`, "a-user-icon"],attrs:{"src":_vm.user.avatar_url,"alt":_vm.user.icon_title,"title":_vm.user.icon_title}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }